import van, { type ChildDom } from "vanjs-core";
import { locale } from "../locale";
import {
	sortedSetAdd,
	sortedSetDelete,
	sortedSetIncludes,
} from "../sorted_set";
import { materialSymbol } from "./material-symbol";
import { button, div, input, label, table, tbody, td, tr } from "./van-tags";

interface SharingFieldParams {
	getAccess: () => string[];
	getNotify: () => string[];
	getOwner: () => string;
	setAccess: (emails: string[]) => void;
	setNotify: (emails: string[]) => void;
}

export function sharingField(args: SharingFieldParams): ChildDom {
	const email = van.state("");
	return div(
		{ class: "field" },
		label(
			{ class: "label" },
			locale.string({
				enGB: "Share",
				deDE: "Teilen",
				frFR: "Partager",
				svSE: "Dela",
			}),
		),
		div(
			{ class: "field has-addons" },
			div(
				{ class: "control is-expanded" },
				input({
					class: "input",
					oninput: (e: Event) => {
						if (!(e.target instanceof HTMLInputElement)) return;
						email.val = e.target.value;
					},
					placeholder: locale.string({
						enGB: "Email",
						deDE: "E-Mail",
						frFR: "E-mail",
						svSE: "E-post",
					}),
					type: "email",
				}),
			),
			div(
				{ class: "control" },
				button(
					{
						class: "button is-primary",
						onclick: () => {
							args.setAccess(
								sortedSetAdd(args.getAccess(), email.val),
							);
							email.val = "";
						},
					},
					locale.string({
						enGB: "Invite",
						deDE: "Einladen",
						frFR: "Inviter",
						svSE: "Bjud in",
					}),
				),
			),
		),
		table({ class: "table is-fullwidth" }, () =>
			tbody(
				args.getAccess().map((email) =>
					tr(
						td(email),
						td(() =>
							sortedSetIncludes(args.getNotify(), email)
								? materialSymbol({
										id: "notifications",
										onclick: () => {
											args.setNotify(
												sortedSetDelete(
													args.getNotify(),
													email,
												),
											);
										},
									})
								: materialSymbol({
										id: "notifications_off",
										onclick: () => {
											args.setNotify(
												sortedSetAdd(
													args.getNotify(),
													email,
												),
											);
										},
									}),
						),
						td(
							email === args.getOwner()
								? materialSymbol({
										id: "star",
									})
								: materialSymbol({
										id: "close",
										onclick: () => {
											args.setAccess(
												sortedSetDelete(
													args.getAccess(),
													email,
												),
											);
										},
									}),
						),
					),
				),
			),
		),
	);
}
